// extracted by mini-css-extract-plugin
export default {"narrowWindow":"pcVideo_narrowWindow_Waqlp","mutedIcon":"pcVideo_mutedIcon_-cLtB"};